// ---------- common ----------
// auth
export const POST_LOGIN = "/auth/login"
export const POST_AUTO_LOGIN = "/auth/auto-login"
export const POST_SIGN_UP = "/auth/register"
export const POST_FORGOT_PASSWORD = "/auth/forgot-password"
export const POST_RESET_PASSWORD = "/auth/reset-password"
export const POST_ACCOUNT_ACTIVATED = "/auth/account-activated"
export const POST_GET_COUNTRIES = "/auth/countries"


export const POST_CHANGE_PASSWORD = "/dashboard/change-password"
export const GET_ADMIN_DASHBOARD_DATA = "/dashboard/admin-dashboard"
export const GET_DASHBOARD_DATA = "/dashboard/dashboard"
export const GET_ACTIVE_PLAN_INFO = "/dashboard/active-plan-info"

///----------------- admin ----------------
//setting
export const GET_ALL_SETTING = "/setting/get-all-setting"
export const POST_UPDATE_SETTING = "/setting/update-setting"
export const POST_ADD_EDIT_DOMAIN = "/setting/add-edit-domain"
export const POST_GET_DOMAIN_LIST = "/setting/get-all-domains"
export const DELETE_DOMAIN = "/setting/delete-domain"

//user role
export const POST_ROLE_LIST = process.env.REACT_APP_API_URL+"user-role/all"
export const DELETE_USER_ROLE = "/user-role/delete"
export const POST_UPDATE_ROLE_STATUS = "/user-role/update-status"
export const POST_ADD_EDIT_ROLE = "/user-role/add-edit"
export const POST_GET_ROLE_DETAIL = "/user-role/detail"

//Admin Users
export const POST_ADMIN_USERS_LIST = process.env.REACT_APP_API_URL+"admin-user/all"
export const DELETE_ADMIN_USERS = "/admin-user/delete"
export const POST_UPDATE_ADMIN_USERS_STATUS = "/admin-user/update-status"
export const POST_ADD_EDIT_ADMIN_USERS = "/admin-user/add-edit"
export const POST_GET_USERS_ADMIN_DETAIL = "/admin-user/detail"

// Users
export const POST_USERS_LIST = process.env.REACT_APP_API_URL+"user/all"
export const DELETE_USERS = "/user/delete"
export const POST_ADMIN_USERS_STATUS = "/user/update-status"
export const POST_GET_USER_DETAIL = "/user/detail"
export const POST_USER_SUBSCRIPTION_LIST = process.env.REACT_APP_API_URL+"user/subscription-list"
export const POST_USER_INVOICES_LIST = process.env.REACT_APP_API_URL+"user/invoice-list"
export const POST_GET_GENERATE_INVOICE = "/user/generate-invoice"

// bank
export const POST_BANK_LIST = process.env.REACT_APP_API_URL+"bank/all"
export const DELETE_BANK = "/bank/delete"
export const POST_UPDATE_BANK_STATUS = "/bank/update-status"
export const POST_ADD_EDIT_BANK = "/bank/add-edit"
export const POST_GET_BANK_DETAIL = "/bank/detail"

// theme
export const POST_CHEQUE_FORMAT_LIST = process.env.REACT_APP_API_URL+"cheque-format/all"
export const DELETE_CHEQUE_FORMAT = "/cheque-format/delete"
export const POST_UPDATE_CHEQUE_FORMAT_STATUS = "/cheque-format/update-status"
export const POST_ADD_EDIT_CHEQUE_FORMAT = "/cheque-format/add-edit"
export const POST_GET_CHEQUE_FORMAT_DETAIL = "/cheque-format/detail"

// plan
export const POST_PLAN_LIST = process.env.REACT_APP_API_URL+"plan/all"
export const POST_UPDATE_PLAN_STATUS = "/plan/update-status"
export const POST_ADD_EDIT_PLAN = "/plan/add-edit"
export const POST_GET_PLAN_DETAIL = "/plan/detail"

// invoice
export const POST_INVOICE_LIST = process.env.REACT_APP_API_URL+"invoice/all"
export const POST_ORDER_LIST = process.env.REACT_APP_API_URL+"invoice/order"
export const POST_ORDER_GENERATE_INVOICE_LIST = "/invoice/generate-invoice"
export const POST_DELETE_ORDER = "/invoice/delete-order"
export const POST_UPDATE_ORDER_STATUS = "/invoice/update-order"
export const POST_ACTIVE_SUBSCRIPTION_LIST = process.env.REACT_APP_API_URL+"invoice/subscription"

export const POST_ENQUIRY_LIST = process.env.REACT_APP_API_URL+"enquiry/all"
export const POST_DELETE_ENQUIRY = "/enquiry/delete"
export const POST_UPDATE_ENQUIRY_STATUS = "/enquiry/update-status"

// ------------------ user -----------------
//setting
export const POST_UPDATE_USER_PROFILE = "/profile/update-user-profile"
export const GET_MY_PROFILE = "/profile/get-my-profile"
export const GET_CREAT_ORDER = "/profile/creat-order"
export const GET_UPDATE_ORDER = "/profile/update-order"
export const GET_UPDATE_CHEQUE_FORMATE = "/profile/update-cheque-formate"

// Uer Invoice
export const POST_USER_INVOICE_LIST = process.env.REACT_APP_API_URL+"web-invoice/all"
export const POST_PDF_INVOICE = process.env.REACT_APP_API_URL.replace('/api/v1/','')+"/pdf/invoice?id="

// cheque-issued
export const POST_CHEQUE_ISSUED_LIST = process.env.REACT_APP_API_URL+"cheque-issued/all"
export const POST_CHEQUE_ISSUED_DETAIL = "/cheque-issued/detail"
export const POST_CHEQUE_ISSUED_ADD_EDIT = "/cheque-issued/add-edit"
export const POST_SEARCH = "/cheque-issued/search"
export const POST_DELETE_SEARCH = "/cheque-issued/delete-search"
export const POST_CHEQUE_PRINT = process.env.REACT_APP_API_URL+"cheque-issued/print"
export const POST_CHEQUE_EXPORT = "/cheque-issued/export"
